// --- React & Redux
import React from "react";
// --- External UI Libraries
// --- Components
import Typography from "@dtci/spellbook/Typography";

export const WelcomeBanner = () => {
  return (
    <div style={{ padding: "1rem 1rem" }}>
      <Typography variant={"T60"}>
        Welcome to Disney&apos;s TAP: Transactional Automation Planning
      </Typography>
      <br />
      <Typography variant={"T30"}>
        Disney&apos;s TAP admin application allows you to access custom
        functions that directly interface with Rightsline
      </Typography>
    </div>
  );
};
